import { createContext } from 'react';
import { INotificationContext } from './INotificationService';

export const NotificationContext = createContext<INotificationContext>({
  notificationService: null,
});
